import { useCallback } from 'react';
import { displayNotification } from 'helpers';
import useValueChange from 'hooks/useValueChange';

const useFormDataLoad = (
    formRes,
    sectionId,
    onPositiveCallback,
    onIssueCallback
) => {
    const handleFormLogic = useCallback((res) => {
        if (res.isError) {
            displayNotification("error", "Error loading form");
            if (onIssueCallback) onIssueCallback();
            return;
        }

        if (res.isSuccess) {
            if (["", undefined].includes(sectionId) && res.data.first_section_id !== "") {
                if (onPositiveCallback) onPositiveCallback(res.data.first_section_id);
            } else if (["", undefined].includes(sectionId) && res.data.first_section_id === "") {
                displayNotification(
                    "warning",
                    "This Form has no parts. Please add parts and try again"
                );
                if (onIssueCallback) onIssueCallback();
            }
        }
    }, [sectionId, onPositiveCallback, onIssueCallback]);

    useValueChange(() => handleFormLogic(formRes), formRes);
}

export default useFormDataLoad;
